import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import {
  Input,
  InputGroup,
  Button,
  CheckPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  FlexboxGrid,
  Container,
  SelectPicker,
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';


interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const ManageCosting = () => {
  
  
 
  const AddedOn = ['Today', 'Yesterday', 'This week', 'Last week', 'This month', 'Last month', 'Last 3 month', 'Last 6 month'].map(
    item => ({ label: item, value: item })
  );

  
  

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Manage Costing</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Costing</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5}>
            <CheckPicker
                data={[]}
                placeholder="Collections"
                
                block
              />
              

              <SelectPicker data={AddedOn} size="xs" appearance="default" placeholder="Added On" style={{ width: 116 }} />
              <SelectPicker data={AddedOn} size="xs" appearance="default" placeholder="Updated On" style={{ width: 116 }} />
              
            </Stack>
          </Stack>
          <Stack direction='column' alignItems='flex-end' spacing={53}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search"/>
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack spacing={10}>
              {/* <Checkbox
                indeterminate={selectedItems.length > 0 && selectedItems.length < data123.length}
                checked={selectedItems.length === data123.length}
                onChange={handleCheckAll}
              >
                Select all
              </Checkbox> */}
              <Button appearance="default" active>
                Product ID Desc
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
           
            {/* <CheckboxGroup inline name="checkboxList" value={value} onChange={handleChange1} > */}
            <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>

           
              
            </FlexboxGrid>

            
          </Panel>
         
        </div>
        
        <Stack className="copyright"    justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
          <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERP Daddy Softwere Solution.</a></p>
        </Stack>

      </Container>
    </>
  );
};
export default ManageCosting;